import { SVGProps } from 'react';

export const TaskListDocumentImage = ({
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="64"
      height="60"
      viewBox="0 0 64 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path
            d="M57.6282 14.3795C59.146 15.8811 60 17.927 60 20.0614V59.9643C60 64.6718 56.1428 63.9619 51.3846 63.9619H12.6154C7.85724 63.9619 4 64.6718 4 59.9643V8.52378C4 3.81622 7.85724 4.91066e-07 12.6154 0H39.8041C41.9119 0 43.9344 0.831313 45.4324 2.31329L57.6282 14.3795Z"
            fill="white"
          />
          <path
            d="M4 59.9643V8.52378C4 3.81622 7.85724 4.91066e-07 12.6154 0H39.8041C41.9119 0 43.9344 0.831313 45.4324 2.31329L57.6282 14.3795C59.146 15.8811 60 17.927 60 20.0614V59.9643C60 64.3775 56.6099 64.0295 52.2656 63.9687L51.3846 63.9619L51.3848 62.9625C51.9902 62.9625 52.5802 62.9738 53.1387 62.9839C53.7012 62.9942 54.2305 63.003 54.7314 62.9996C55.7455 62.9927 56.5693 62.9344 57.2217 62.7624C57.8557 62.5953 58.2553 62.3401 58.5156 61.9845C58.7839 61.6181 59 61.0138 59 59.9643V20.0613C59 18.1937 58.2528 16.4035 56.9248 15.0896L44.7285 3.02359C43.4179 1.72694 41.6479 0.999404 39.8037 0.999404H12.6152C8.3999 0.999485 5 4.37816 5 8.52422V59.9643C5 61.0138 5.21607 61.6181 5.48438 61.9845C5.74474 62.3401 6.14429 62.5953 6.77832 62.7624C7.43068 62.9344 8.25455 62.9927 9.26855 62.9996C9.76946 63.003 10.2988 62.9942 10.8613 62.9839C11.4198 62.9738 12.0098 62.9625 12.6152 62.9625L12.6154 63.9619C7.85724 63.9619 4 64.6718 4 59.9643ZM51.3848 62.9625L51.3846 63.9619H12.6154L12.6152 62.9625H51.3848Z"
            fill={`url(#paint0_${props.id})`}
          />
          <path
            d="M37 4.82555C37 3.0448 39.1543 2.153 40.4142 3.41218L56.5858 19.5741C57.8457 20.8333 56.9534 22.9863 55.1716 22.9863H41C38.7909 22.9863 37 21.1965 37 18.9887V4.82555Z"
            fill={`url(#paint1_${props.id})`}
          />
          <path
            d="M11 20.4878C11 19.1079 12.1193 17.9893 13.5 17.9893H27.5C28.8807 17.9893 30 19.1079 30 20.4878C30 21.8677 28.8807 22.9863 27.5 22.9863H13.5C12.1193 22.9863 11 21.8677 11 20.4878Z"
            fill={`url(#paint2_${props.id})`}
          />
          <path
            d="M11 29.4824C11 28.1025 12.1193 26.9839 13.5 26.9839H45.5C46.8807 26.9839 48 28.1025 48 29.4824C48 30.8623 46.8807 31.9809 45.5 31.9809H13.5C12.1193 31.9809 11 30.8623 11 29.4824Z"
            fill={`url(#paint3_${props.id})`}
          />
        </g>
      </g>

      <defs>
        <linearGradient
          id={`paint0_${props.id}`}
          x1="40"
          y1="-14.4914"
          x2="18.524"
          y2="67.4661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="0.780666" stopColor="white" />
        </linearGradient>

        <linearGradient
          id={`paint1_${props.id}`}
          x1="48.5"
          y1="-2.29247e-08"
          x2="48.5"
          y2="22.9863"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>

        <linearGradient
          id={`paint2_${props.id}`}
          x1="20.5"
          y1="17.9893"
          x2="20.5"
          y2="22.9863"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>

        <linearGradient
          id={`paint3_${props.id}`}
          x1="29.5"
          y1="26.9839"
          x2="29.5"
          y2="31.9809"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>

        <clipPath id={`clip0_${props.id}`}>
          <rect width="64" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
